import Header from '../Header/Header'
import Footer from '../footer/Footer'
import './aboutUs.css'

const AboutUs = () => {
  return (
    <>
      <Header />
      <div className="aboutUs-container">
        <h1 className="aboutUs-text">О нас</h1>

        <div className="first-blok-aboutUs">
          <p>
            JAGU-MOOK - это веб-сайт, предлагающий курсы по программированию, информатике,
            психологии и другим предметам, действующий как комплексная образовательная платформа.
            Наша платформа предлагает широкий спектр курсов, позволяющих студентам развивать свои
            навыки и углублять знания в различных областях. Мы стремимся создать приятную и
            эффективную среду для обучения, где каждый студент может достичь успеха.
          </p>
        </div>

        <div className="second-blok-aboutUs">
          <h1 className="aboutUs-text">Миссия платформы</h1>

          <p>
            Миссия платформы — сделать качественное образование доступным для студентов и
            преподавателей университета ЖАГУ и широкой аудитории, используя современные цифровые
            технологии обучения. Мы стремимся развивать профессиональные, языковые и цифровые
            навыки, поддерживать непрерывное обучение и повышение квалификации, а также создавать
            образовательную среду, способствующую личностному и профессиональному росту.
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutUs
